module.exports = __webpack_public_path__ + "img/1567974624.9e7eb68d.jpg";